import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ProfileDataForm } from "../../../types/Profile";
import axios from "axios";
import { PROFILE } from "./useProfile";

export type UpdateProfileParams = {
	orgId: number;
	data: ProfileDataForm;
};

const updateProfile = ({ orgId, data }: UpdateProfileParams) => {
	return axios.put(`/job/company/api/profile?orgId=${orgId}`, data);
};

export const useUpdateProfile = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: UpdateProfileParams) => updateProfile(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [PROFILE],
			});
		},
	});
};
